import { useState } from 'react';

import { useFloatingAlert } from '../../../hooks/useFloatingAlert';
import { CommerceServices } from '../../../services/commerce';
import { Button, ContainerButtons, ModalContent, ModalDescription, ModalTitle } from './styles';
interface ModalMerchantStatus {
	setShowFinalizedModal: () => void;
	statusMerchant: boolean;
	merchantCode: string;
}
const ModalMerchantStatus = ({
	statusMerchant,
	setShowFinalizedModal,
	merchantCode,
}: ModalMerchantStatus) => {
	const { handleShowAlert } = useFloatingAlert();
	const [loadingButton, setLoadingButton] = useState<boolean>(false);

	const setMerchantStatus = async () => {
		await setLoadingButton(true);
		try {
			await CommerceServices.setMerchantActive({
				merchant_code: merchantCode,
				status: statusMerchant ? 'false' : 'true',
			});

			handleShowAlert({
				type: 'success',
				message: statusMerchant
					? 'El comercio ha sido desactivado éxito'
					: 'El comercio ha sido activado con éxito',
			});
			setShowFinalizedModal();
		} catch (error: any) {
			handleShowAlert({
				type: 'success',
				message: 'Algo salió mal, intenta de nuevo más tarde.',
			});
			setShowFinalizedModal();
		}
	};

	return (
		<ModalContent>
			<ModalTitle>¿Estás seguro?</ModalTitle>
			<ModalDescription>
				{statusMerchant
					? 'Esta acción desactivará el comercio y no podrá recibir más pagos.'
					: 'Esta acción habilitará que el comercio pueda recibir pagos.'}
			</ModalDescription>
			<ContainerButtons>
				<Button variant="pure" onClick={setShowFinalizedModal}>
					Cancelar
				</Button>
				<Button variant="abell" onClick={setMerchantStatus} disabled={loadingButton}>
					Sí, estoy seguro
				</Button>
			</ContainerButtons>
		</ModalContent>
	);
};

export { ModalMerchantStatus };
